import { render, staticRenderFns } from "./LayoutTeaserGrid.vue?vue&type=template&id=3b1dd7b0&functional=true&"
import script from "./LayoutTeaserGrid.vue?vue&type=script&lang=ts&"
export * from "./LayoutTeaserGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports